import { Button, Dimmer, Loader, Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { InstantSearch } from "react-instantsearch";

import Flex from "../../../../components/Flex/Flex";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import { useAlgoliaSearchClient } from "../../../algolia/state/algoliaSearchClient";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

import ReaderSearchResults from "../ReaderSearchResults/ReaderSearchResults";

import CustomConfigure from "./components/CustomConfigure";
import ReaderSearchBar from "./components/ReaderSearchBar";
import ResultText from "./components/ResultText";
import ReaderFilterForm from "./forms/ReaderFilterForm";

export default function ReaderSearchForm({ language, selectedReaderIds = [], submitText, onSubmit, onClose }) {
	const { t } = useTranslation();

	const {
		form,
		watch,
		formState,
		onSubmit: onClickSubmit,
	} = useSimpleForm({
		onSubmit,
		onSuccess: () => {
			form.setValue("reader", null);
		},
	});

	const [searchClient] = useAlgoliaSearchClient();

	const indexName = "readers";

	const [filtersOpen, reader] = watch(["filtersOpen", "reader"]);

	return (
		<Modal open onClose={onClose} style={{ overflow: "hidden" }}>
			<LoadingContext loading={!searchClient}>
				<InstantSearch indexName={indexName} searchClient={searchClient}>
					<CustomConfigure form={form} language={language} />

					<Modal.Header>
						<Form form={form}>
							<ReaderSearchBar />

							{filtersOpen && <ReaderFilterForm />}
						</Form>
					</Modal.Header>

					<Modal.Content scrolling style={{ padding: 0, maxHeight: "40vh" }}>
						<ReaderSearchResults
							language={language}
							selectedReaderIds={selectedReaderIds}
							selectedId={reader?.id}
							onClick={(clickedReader) =>
								form.setValue("reader", clickedReader.id !== reader?.id ? clickedReader : null)
							}
						/>
					</Modal.Content>

					<Modal.Actions>
						<Flex>
							<ResultText />

							<Flex style={{ justifyContent: "flex-end", gap: 10 }}>
								<Button content={t("close")} onClick={onClose} />
								<Button primary content={submitText} disabled={!reader} onClick={onClickSubmit} />
							</Flex>
						</Flex>
					</Modal.Actions>

					{formState.isSubmitting && (
						<Dimmer active inverted>
							<Loader />
						</Dimmer>
					)}
				</InstantSearch>
			</LoadingContext>
		</Modal>
	);
}
